const translations = {
  'fields.name': 'Name',
  'fields.createdAt': 'Created at',
  'fields.updatedAt': 'Updated at',
  'fields.branch': 'Branch',
  'fields.headquarter': 'Headquarter',
  'fields.status': 'Status',
  'fields.checklist': 'Checklist',
  'fields.user': 'User',
  'fields.scheduling': 'Scheduled at',
  'fields.endDate': 'Completed at',
  'fields.notes': 'Notes',
  'fields.checkIn': 'Check In',
  'fields.checkOut': 'Check Out',
  'fields.headquarterBranch': 'Client',
  'fields.assets': 'Assets',
  'fields.activityScore': 'Activity Score',
  'fields.negatives': 'Answers No',
  'fields.actionPlans': 'Action Plans',
  'fields.serviceTime': 'Service Time',
  'resume.filters.questionTypes': 'Question type',
  'resume.filters.answerTypes': 'Answers no',
  'resume.filters.actionPlans': 'Action Plans',
  'resume.accordion.general': 'Overview',
  'resume.accordion.negatives': 'Answers No',
  'resume.accordion.actionPlans': 'Action Plans',
  'resume.accordion.pendencies': 'Pendencies',
  'execution.accordion.general': 'Details',
  activities: 'Activities',
  listing: 'Listing',
  actionPlans: 'Action Plans',
  'resume.pdf.betaAlertTitle': 'The new PDF is underdevelopment',
  'resume.pdf.betaAlertMessage':
    'Would you like to be redirected to the previous version so you can export in PDF format?',
  'pdf.options.printSettingsTitle': 'Print settings',
  'pdf.options.showQuestionInfo': 'Show question details',
  'pdf.options.hideConfidentialInfo': 'Hide confidential additional fields',
  'pdf.options.hidePrivateQuestion': 'Hide confidential questions',
  'pdf.options.hideChildrenServiceOrders': 'Hide child activities',
  'pdf.options.childrenFieldsTitle': 'Child activity fields',
  'pdf.options.showField': 'Show {{field}}',
  'pdf.options.headerImageTitle': 'Header image',
  'pdf.options.headerImageHeight': 'Image height',
  'pdf.options.add': 'Add',
  'pdf.counters.score': 'Score',
  'pdf.counters.nonCompliances': 'Non-compliances',
  'pdf.counters.actionPlans': 'Action plans',
  'pdf.counters.time': 'Time',
  'pdf.reason': 'Reason',
  'pdf.createdAt': 'Created at {{date}}',
  anonymousResponse: 'Answered anonymously',
  'show.userOrGroup': 'User/Group',
  'show.placeOrPerson': 'Place/Person',
  'show.asset': 'Asset',
  'show.checklist': 'Checklist',
  'show.scheduling': 'Scheduling',
  'show.priority': 'Priority',
  'show.sla': 'SLA',
  'show.address': 'Address',
  'show.description': 'Description',
  'show.publicExecutionLink': 'Public execution link',
  'show.publicResumeLink': 'Public resume link',
  'show.documents': 'Documents',
  'show.history': 'History',
  'show.noDate': 'No date',
  'show.noPriority': 'No priority',
  'show.openedAt': 'Opened at',
  'tabs.details': 'Details',
  'tabs.timeline': 'Timeline',
  'tabs.triggerEvents': 'Trigger events',
  'tabs.audit': 'Audit',
  'bulkEdit.title': 'Bulk registration',
  'clone.title': 'Cloning Activity',
  'clone.message': 'This action will create a new activity with the same data from activity {{yearlyId}}',
  'editStatus.title': 'Changing status of activity',
  'editStatus.title_plural': 'Changing status of activities',
  'export.title': 'Exporting activity',
  'export.title_plural': 'Exporting activities',
  'remove.button': 'Remove',
  'execution.title': 'Responding activity: {{title}}',
  'resume.title': 'Summary: {{yearlyId}}',
  'resume.fullResume': 'Full summary',
  'statusReason.unproductiveReason': 'Unproductive reason',
  'statusReason.evidences': 'Evidences',
  'statusReason.signature': 'Signature',
  'statusReason.name': 'Name',
  'statusReason.document': 'Document',
  'indicators.nonCompliances': 'Non-compliances',
  'execution.saveError': 'Error saving answers',
  'execution.requiredAnswersMissing': 'Required answers missing',
  'execution.requiredAnswersMissingMessage': 'Check the questions with red tags.',
  'execution.sendError': 'An error occurred while sending answers',
  'execution.sendErrorMessage': 'Check the questions with red tags.',
  'execution.paused': 'Activity paused',
  'execution.completed': 'Activity completed!',
  'execution.saved': 'Activity saved!',
  'resume.generateCustomDocument': 'Generate Custom Document',
  'resume.generatePDF': 'Generate PDF',
  'export.validation.missingIds': 'Missing ids',
  'export.validation.required': 'Required field',
  'export.sendingRequest': 'Sending request...',
  'export.generatingFile': 'Generating file...',
  'export.error': 'An error occurred while exporting!',
  'bulkEdit.openingAsChild': 'Opening as child activity of:',
  'bulkEdit.makeParentPending': 'Make parent pending',
  'bulkEdit.fields.code': 'Code',
  'bulkEdit.fields.name': 'Name',
  'bulkEdit.fields.checklist': 'Checklist',
  'bulkEdit.fields.placeType': 'Destination type',
  'bulkEdit.fields.place': 'Destination',
  'bulkEdit.fields.asset': 'Asset',
  'bulkEdit.fields.responsible': 'Responsible',
  'bulkEdit.fields.address': 'Address',
  'bulkEdit.fields.scheduling': 'Scheduling',
  'bulkEdit.fields.priority': 'Priority',
  'bulkEdit.fields.description': 'Description',
  'interpolations.activityCode': 'Activity code',
  'interpolations.activityName': 'Activity name',
  'interpolations.activityDescription': 'Activity description',
  'interpolations.checklistName': 'Checklist name',
  'interpolations.status': 'Status',
  'interpolations.projectName': 'Project name',
  'interpolations.placeName': 'Place name',
  'interpolations.publicResumeLink': 'Public resume link',
  'interpolations.publicExecutionLink': 'Public execution link',
  'interpolations.userName': 'User name',
  'interpolations.userEmail': 'User email',
  'interpolations.userGroup': 'User group',
  'interpolations.destinationName': 'Destination name',
  'interpolations.fullDestinationName': 'Full destination name',
  'interpolations.schedulingDate': 'Scheduling date',
  'interpolations.openingDate': 'Opening date (start or creation)',
  'interpolations.completionDate': 'Completion date',
  'interpolations.savedActivityUser': 'Saved activity user',
  'interpolations.updatedActivityPlace': 'Updated activity place',
  'interpolations.updatedActivityAsset': 'Updated activity asset',
  'interpolations.savedActivityChecklist': 'Saved activity checklist',
  'interpolations.updatedNonCompliancePlace': 'Updated non-compliance place',
  'interpolations.updatedNonComplianceAsset': 'Updated non-compliance asset',
  'interpolations.groups.activity': 'Activity',
  'interpolations.groups.user': 'User',
  'interpolations.groups.destination': 'Destination',
  'interpolations.groups.dates': 'Dates'
}

export default translations
